import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useAuth } from '../Auth/AuthContext';
import adsTxtApiService from '../../ApiServices/AdsTxtApiService/AdTxtApiService';

export default function AdsTxtContent({ isAdCode }) {
    const filetype = isAdCode ? "AdCodeTxt" : "AdTxt";
    const [fileContent, setFileContent] = useState("");

    const Auth = useAuth();
    const user = Auth.authState.user;
    const isAdmin = Auth.authState.roles === "Admin";

    // Editing Mode State
    const [isEditing, setIsEditing] = useState(false);

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleTextChange = (event) => {
        setFileContent(event.target.value);
    };

    const updateTxtFile = async () => {
        const blob = new Blob([fileContent], { type: "text/plain" });
        const file = new File([blob], "adfile.txt", { type: "text/plain" });

        const formData = new FormData();
        formData.append("file", file);
        formData.append("adFileType", filetype);

        await adsTxtApiService.UpdateAdFile(formData);
        setIsEditing(false);
        toast.success("File updated successfully");
    };

    useEffect(() => {
        const fetchFileContent = async () => {
            try {
                let fileTxt = await adsTxtApiService.getAdFile(filetype);
                setFileContent(fileTxt);
            } catch (error) {
                console.error("Error fetching ad file:", error);
                toast.error("Failed to load ads.txt");
            }
        };
        fetchFileContent();
    }, []);

    return (
        <div className="p-4 md:p-6">
            <ToastContainer />
            <div className="bg-white shadow-md rounded-lg p-5">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold text-gray-700">Ad File Content</h2>
                    {isAdmin && (
                        <button
                            onClick={handleEditClick}
                            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md transition"
                        >
                            Edit
                        </button>
                    )}
                </div>

                {/* Scrollable Content Section */}
                <div className="overflow-x-auto border border-gray-200 p-3 bg-gray-50 rounded-lg max-h-[400px]">
                    {!isEditing ? (
                        <pre className="whitespace-pre-wrap text-gray-800 max-w-full md:max-w-3xl overflow-x-auto">
                            {fileContent}
                        </pre>

                    ) : (
                        <div className="flex flex-col space-y-3">
                            <textarea
                                value={fileContent}
                                onChange={handleTextChange}
                                rows="10"
                                className="w-full border p-2 rounded-md"
                            />
                            <div className="flex gap-3">
                                <button
                                    onClick={updateTxtFile}
                                    className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md transition"
                                >
                                    Save
                                </button>
                                <button
                                    onClick={() => setIsEditing(false)}
                                    className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md transition"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
